// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function TabPane(_) {
  return null;
}